<template>
  <router-view />
</template>

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
  .select2-container--open {
      z-index: 1056;
  }
  .select2-container {
      width: 100% !important;
  }
</style>
